export const Alert = {
  baseStyle: {
    container: {
      color: 'white',
      borderRadius: '8px',
    },
  },
  variants: {
    success: {
      container: {
        bg: 'success.toast',
      },
    },
    error: {
      container: {
        bg: 'error.toast',
      },
    },
    warning: {
      container: {
        bg: 'warning.toast',
      },
    },
    info: {
      container: {
        bg: 'accent.default',
      },
    },
  },
  defaultProps: {
    variant: 'error',
  },
};
